"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getExcursionOrderLineChanges = void 0;
const dayjs = require("dayjs");
const pluralize_1 = require("../pluralize");
const getExcursionOrderLineChanges = (previous, current) => {
    const changed_items = [];
    const changes = {};
    // Check if date has changed
    if (previous.where_when_who.date !== current.where_when_who.date) {
        changed_items.push("Date");
        changes.date = {
            has_changed: true,
            previous_value: dayjs(previous.where_when_who.date).format("ddd, Do MMM YYYY"),
        };
    }
    // has the number of people changed?
    if (previous.where_when_who.number_of_people !==
        current.where_when_who.number_of_people) {
        changed_items.push("No. of guests");
        changes.people = {
            has_changed: true,
            previous_value: (0, pluralize_1.pluralize)(previous.where_when_who.number_of_people, "Guest", "Guests"),
        };
    }
    // FUCK KNOWS HOW, BUT MAY HAVE TO WORK OUT THAT THE HOTEL HAS CHANGED AND THEN TELL THE EXCURSION PEOPLE ACCORDINGLY
    return {
        ...changes,
        changes: changed_items,
    };
};
exports.getExcursionOrderLineChanges = getExcursionOrderLineChanges;
